var exports = {
  "nM": "AccountTab.module__row___VVlIbW",
  "Db": "AccountTab.module__accountRows___VVlIbW",
  "u4": "AccountTab.module__rowContent___VVlIbW",
  "Pf": "AccountTab.module__label___VVlIbW",
  "h_": "AccountTab.module__description___VVlIbW",
  "i4": "AccountTab.module__warningText___VVlIbW",
  "yF": "AccountTab.module__divider___VVlIbW",
  "Hk": "AccountTab.module__claimButton___VVlIbW",
};

module.exports = exports;
